import { IZepdLog } from 'isogd-file-rest';

export class LogFileGldController {
    static $inject = ['$uibModalInstance', 'logs'];
    constructor(private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance, private logs: IZepdLog[]) {
    }

    cancel() {
        this.$uibModalInstance.close();
    }
}


// WEBPACK FOOTER //
// ./src/components/log-files/logFileDlg.ts